export default __webpack_public_path__ + "static/media/logo_hgtag.fff38ade.png";